/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { lsolveDependencies } from './dependenciesLsolve.generated.js';
import { lupDependencies } from './dependenciesLup.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { sluDependencies } from './dependenciesSlu.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { usolveDependencies } from './dependenciesUsolve.generated.js';
import { createLusolve } from '../../factoriesAny.js';
export var lusolveDependencies = {
  DenseMatrixDependencies,
  lsolveDependencies,
  lupDependencies,
  matrixDependencies,
  sluDependencies,
  typedDependencies,
  usolveDependencies,
  createLusolve
};